import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {select, Store} from '@ngrx/store';
import {TranslationService} from '../../services/translation.service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {
  TranslationFormModel, TranslationModel, TranslationProgressMentStatus,
  TranslationSupportiveLanguage
} from '../../models/translation.model';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {
  TranslationFileTypes,
  TranslationForms, TranslationFormsFrameId, TranslationStatus, TranslationToolNames
} from '../../models/translation.constants';
import {BehaviorSubject} from 'rxjs';
import {StringUtility} from '@shared/utility/string-utility';
import {CommandService} from '@core/services/command.service';
import {ConvertHtmlToPdfCommand} from '../../commands/translation.commands';
import {IToastState} from '@shared/store/toast/toast-reducer';
import {
  getNotification
} from '@shared/store/toast/toast-selectors';
import {ActivatedRoute, Router} from '@angular/router';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {getApplicationWithId, ParticleState} from '@shared/store/reducers/particle.reduer';
import {TaxFormsConfig} from '@features/tax-forms/tax-forms-config';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {toString} from '@progress/kendo-angular-intl';
import {HtmlConverterService} from '@shared/services/html-converter-api.service';
import {effectiveZoom, screenPxToLocal} from '@shared/helpers/effective-zoom';

@Component({
    standalone: false,
    selector: 'particle-translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.scss']
})
export class TranslationComponent implements OnInit, IPlatformToolComponent, OnDestroy, AfterViewInit {
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  invalidateSubject: InvalidateSubject;
  translationId: any;
  unSubscribe$ = new Subject<void>();
  translationModel: TranslationModel = new TranslationModel();
  originalForm$: BehaviorSubject<TranslationFormModel> = new BehaviorSubject(new TranslationFormModel());
  translatedForm$: BehaviorSubject<TranslationFormModel> = new BehaviorSubject(new TranslationFormModel());
  progressStatus$: BehaviorSubject<TranslationProgressMentStatus> = new BehaviorSubject(new TranslationProgressMentStatus());
  actionChanges$: BehaviorSubject<any> = new BehaviorSubject({});
  language$: any;
  translationSupportiveLanguage: TranslationSupportiveLanguage[] = [];
  supportiveLanguageQueryKey = 'TranslationSupportiveLanguage';
  isLeftFrameLoaded = false;
  isRightFrameLoaded = false;
  oldWindowValue = 0;
  private notifications: any;
  isDown = false;
  div: any;
  divMagicScrollerContainer: any;
  oldValue = 0;
  mousePosition: any;
  offset = [0, 0];
  /** The scroller's net CSS zoom, read once per drag — clientY is screen px, style.top is local px. */
  private dragZoom = 1;
  lowLengthSide;
  frameRight: any;
  frameLeft: any;
  divIconSquareUp: HTMLElement;
  divIconSquareDown: HTMLElement;
  clientHeight: number;
  rightFrameScrollTop: any;
  rightFileName = ' ';
  leftFileName = ' ';
  private baseUrl: string;
  private authToken: string;

  constructor(private toastStore: Store<IToastState>,
              private particleStore: Store<ParticleState>,
              private translationService: TranslationService,
              private activatedRoute: ActivatedRoute,
              private httpClient: HttpClient,
              public sanitizer: DomSanitizer,
              public changeDetectorRef: ChangeDetectorRef,
              private commandService: CommandService,
              private router: Router,
              private queryStore: Store<IQueryState>,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private htmlConverterService: HtmlConverterService,
              private platformSidebarService: PlatformSidebarService) {}



  ngAfterViewInit(): void {
    this.div = <HTMLElement>document.getElementById('dummy-scroll-container-range');
    this.divMagicScrollerContainer = <HTMLElement>document.getElementById('magic-scroller-container');
    this.divIconSquareUp = <HTMLElement>document.getElementById('caret-square-up');
    this.divIconSquareDown = <HTMLElement>document.getElementById('caret-square-down');
    // this.handleMagicSliderData();

    this.clientHeight = document.getElementById('dummy-scroll-container').offsetHeight - 25;

  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.unSubscribe$)).subscribe((params: any) => {
      if (params.translationId) {
        if (this.selectedTab && this.selectedTab.tabData && this.selectedTab.tabData && this.selectedTab.tabData.TranslationId) {
          this.translationId = this.selectedTab.tabData.TranslationId;
          this.getTranslationModel(this.translationId);
        }
      }
    });
    this.language$ = this.queryStore.pipe(select(getQueryResponse, this.supportiveLanguageQueryKey), takeUntil(this.unSubscribe$));
    this.language$.subscribe(language => {
      if (language) {
        this.translationSupportiveLanguage = language;
        if (this.translationSupportiveLanguage && this.translationSupportiveLanguage.length > 0) {
          this.translationSupportiveLanguage = this.translationService.sortTranslationSupportiveLanguage(this.translationSupportiveLanguage);
        }
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.supportiveLanguageQueryKey, {});
    // console.log('outside:', this.translationId);
    /*    this.notifications = this.toastStore.pipe(select(getNotification, this.translationId), takeUntil(this.unSubscribe$));
        this.notifications.subscribe(notification => {
          console.log('inside notification:', this.translationId, notification);
          const payload = notification(this.translationId);
          console.log('inside notification payload:', payload);
          if (payload && payload.id === this.translationId) {
            this.translationModel = payload;
            this.processTranslationModel();
          }
        });*/

    if (this.handler && this.handler.magicLinkModelValueChanged) {
      this.handler.magicLinkModelValueChanged.pipe(takeUntil(this.unSubscribe$)).subscribe(commamd => {
        this.handleMagicLinkValueChanged(commamd);
      });
    }
  }

  private getTranslationModel(translationId: string) {
    this.fuseSplashScreenService.show();
    this.makeIframeUnload();
    this.translationService.getTranslatinModel(translationId).pipe(takeUntil(this.unSubscribe$)).subscribe(translationModel => {
      this.fuseSplashScreenService.hide();
      // console.log('translation model in get:', translationModel);
      this.translationModel = translationModel;
      if (this.translationModel.leftFile.fileName) {
        this.leftFileName = this.translationModel.leftFile.fileName;
      }
      if (this.translationModel.rightFile.fileName) {
        this.rightFileName = this.translationModel.rightFile.fileName;
      }
      this.platformSidebarService.openActivityFeedByReferenceCode(translationModel.referenceCode, this.leftFileName + ' ' + this.rightFileName, true, false);
      this.saveTranslationModelInHandler(this.translationModel);
      this.processTranslationModel();
    }, err => {
      this.snackBarService.showError('Model fetching failed!!!!!!');
      this.fuseSplashScreenService.hide();
    });
  }

  private processTranslationModel() {
    switch (this.translationModel.status) {
      case TranslationStatus.Completed:
        this.handleActiveStatus();
        break;
      default:
        this.handleLazyStatus();
    }
  }

  private handleActiveStatus() {
    // console.log('handling active status:', this.translationModel);
    this.setLeftFormData(this.translationModel.leftFile);
    this.setRightFormData(this.translationModel.rightFile);
    if (!this.translationModel.leftFile.hasPreview) {
      if (this.translationModel.status === TranslationStatus.InProgress) {
        this.emitLeftFormProgressStatus();
      } else {
        this.emitLeftFormProgressStatus(-1);
      }
    }
    if (!this.translationModel.rightFile.hasPreview) {
      if (this.translationModel.status === TranslationStatus.InProgress) {
        this.emitRightFormProgressStatus();
      } else {
        this.emitRightFormProgressStatus(-1);
      }
    }
  }

  onFrameLoaded($event) {
    // console.log("event",$event)
    if ($event.frameId === TranslationFormsFrameId.LeftForm) {
      this.isLeftFrameLoaded = true;
      this.listenFrameEditDirtyNess(TranslationFormsFrameId.LeftForm);
      this.checkBothFrameLoaded();
    }
    if ($event.frameId === TranslationFormsFrameId.RightForm) {
      this.isRightFrameLoaded = true;
      this.listenFrameEditDirtyNess(TranslationFormsFrameId.RightForm);
      this.checkBothFrameLoaded();
    }
  }

  checkBothFrameLoaded() {
    if (this.isLeftFrameLoaded && this.isRightFrameLoaded) {
      const frameLeft = <HTMLIFrameElement>document.getElementById(TranslationFormsFrameId.LeftForm);
      const frameRight = <HTMLIFrameElement>document.getElementById(TranslationFormsFrameId.RightForm);
      this.handleMagicSliderData(frameLeft, frameRight);
    }
  }

  emitLeftFormProgressStatus(progress?: number) {
    if (!progress) {
      progress = this.translationModel.progress;
    }
    this.emitProgressStatus(TranslationForms.LeftForm, this.translationModel.status, this.translationModel.message, progress);
  }

  emitRightFormProgressStatus(progress?: number) {
    if (!progress) {
      progress = this.translationModel.progress;
    }
    this.emitProgressStatus(TranslationForms.RightForm, this.translationModel.status, this.translationModel.message, progress);
  }

  setLeftFormData(leftForm: TranslationFormModel) {
    this.originalForm$.next(leftForm);
  }

  setRightFormData(rightForm: TranslationFormModel) {
    this.translatedForm$.next(rightForm);
  }

  emitProgressStatus(formId, status, message, percentage) {
    const progress = new TranslationProgressMentStatus();
    progress.formId = formId;
    progress.status = this.translationService.getPretifiedStatus(status);
    progress.message = message;
    progress.percentage = percentage;
    // this.progressStatus$.next(progress); // todo: removed!!
  }

  private handleLazyStatus() {
    this.originalForm$.next(new TranslationFormModel());
    this.translatedForm$.next(new TranslationFormModel());
    this.emitProgressStatus(TranslationForms.LeftForm, this.translationModel.status, this.translationModel.message, -1);
    this.emitProgressStatus(TranslationForms.RightForm, this.translationModel.status, this.translationModel.message, -1);
  }

  doTranslation(frameId, fromLang: string = '', toLang: string = '') { // in the bread var
    // console.log('translationModel:', this.translationModel, fromLang, toLang);
    if (!fromLang) {
      fromLang = this.translationModel.leftFile.language;
    }
    if (!toLang) {
      toLang = this.translationModel.rightFile.language;
    }
    const leftInnerHtml = this.getFrameInnerHtml(frameId);
    const file = new File(['<html>' + leftInnerHtml + '</html>'], `${StringUtility.getFileNameExcludingExtension(this.translationModel.leftFile.fileName)}_translated.html`, {type: 'text/html'});
    this.fuseSplashScreenService.show();
    this.translationService.uploadClientFile(file, this.translationId).pipe(takeUntil(this.unSubscribe$)).subscribe(fileId => {
      this.requestTranslation(fileId, fromLang, toLang);
    });
  }

  private getFrameInnerHtml(frameId: string) {
    const iframe = <HTMLIFrameElement>document.getElementById(frameId);
    let divs = iframe.contentDocument.querySelectorAll('div');
    Array.from(divs).forEach((element: Element) => {
      element.setAttribute('contenteditable', 'false');
    });
    const iFrameHtml = iframe.contentDocument.querySelector('html');
    const htmlString = iFrameHtml.innerHTML;
    divs = iframe.contentDocument.querySelectorAll('div');
    Array.from(divs).forEach((element: Element) => {
      element.setAttribute('contenteditable', 'true');
    });
    // console.log('frame document info:', frameId, scrollingElement, scrollingElement.scrollTop, scrollingElement.scrollWidth, scrollingElement.scrollHeight, htmlString);
    return htmlString;
  }

  private saveTranslationModelInHandler(translationModel) {
    this.handler.valueChanged({action: {id: 'SaveTranslationModel'}, item: translationModel});
  }

  private handleMagicLinkValueChanged(action: any) {
    console.log(action, this.translationModel);
    if (action) {
      switch (action.name) {
        case 'TranslateFormCommand':
          this.handleTranslateFormCommand();
          break;
        case 'FxRateCommand':
        case 'FixSpacingCommand':
        case 'ResetCommand':
          this.handleToolbarActionCommand(action.command);
          break;
        case 'TranslationSettingsCommand':
          this.handleTranslateFormCommand(action.formConfig.formLangugage, action.formConfig.toLanguage);
          break;
        case 'DownloadHtmlAsPdfCommand':
          this.downloadSideBySidePdf(<PlatformCommand>action.command);
          break;
      }
    }
  }


  downloadSideBySidePdf(command: PlatformCommand) {
    const leftIframe = <HTMLIFrameElement>document.getElementById(TranslationFormsFrameId.LeftForm);
    const rightIframe = <HTMLIFrameElement>document.getElementById(TranslationFormsFrameId.RightForm);
    const leftFrameScrollingElement = leftIframe.contentDocument.scrollingElement;
    const rightFrameScrollingElement = rightIframe.contentDocument.scrollingElement;
    this.configureBothSideBySideFormDownloadCommand(command, leftFrameScrollingElement, rightFrameScrollingElement);
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      this.fuseSplashScreenService.hide();
      if (response) {
        this.snackBarService.showInformation('Your download is processing. You will be notified once your download is ready.');
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError('Download failed!!!');
    });
  }

  configureBothSideBySideFormDownloadCommand(command: PlatformCommand, leftFrameScrollingElement, rightFrameScrollingElement) {
    command.fieldValues['LeftFormName'] = this.translationModel.leftFile.fileName;
    command.fieldValues['RightFormName'] = this.translationModel.rightFile.fileName;
    command.fieldValues['LeftFrameHeight'] = leftFrameScrollingElement.scrollHeight;
    command.fieldValues['RightFrameHeight'] = rightFrameScrollingElement.scrollHeight;
    command.fieldValues['LeftFrameWidth'] = leftFrameScrollingElement.scrollWidth;
    command.fieldValues['RightFrameWidth'] = rightFrameScrollingElement.scrollWidth;
    command.fieldValues['LeftFrameScrollTop'] = leftFrameScrollingElement.scrollTop;
    command.fieldValues['RightFrameScrollTop'] = rightFrameScrollingElement.scrollTop;
    const leftHtml = this.getFrameInnerHtml(TranslationFormsFrameId.LeftForm);
    const rightHtml = this.getFrameInnerHtml(TranslationFormsFrameId.RightForm);
    command.fieldValues['LeftPanelHtml'] = this.htmlConverterService.getB64EncodeUnicodeString(leftHtml);
    command.fieldValues['RightPanelHtml'] = this.htmlConverterService.getB64EncodeUnicodeString(rightHtml);
  }


  private handleTranslateFormCommand(fromLang: string = '', toLang: string = '') {
    if (this.translationModel.leftFile.fileType === TranslationFileTypes.Pdf) {
      if (!this.isLeftFrameLoaded) {
        this.snackBarService.showInformation('Document in left panel is not yet loaded.');
        return;
      }
      if (this.translationModel && this.translationModel.status === TranslationStatus.Completed) {
        this.doTranslation(TranslationFormsFrameId.LeftForm, fromLang, toLang);
      }
    } else {
      this.requestTranslation('', this.translationModel.leftFile.language, this.translationModel.rightFile.language);
    }
  }

  private handleToolbarActionCommand(command: any) {
    if (!this.isRightFrameLoaded) {
      this.snackBarService.showInformation('Document in right panel is not yet loaded.');
      return;
    }
    this.actionChanges$.next(command); // action to childs
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    document.removeEventListener('mouseup', this.handleMouseUpEvent, true);
    window.removeEventListener('resize', this.handleWindowResizeEvent, true);
    if (this.frameLeft && this.frameLeft.contentWindow && this.frameLeft.contentWindow.document) {
      this.frameLeft.contentWindow.document.removeEventListener('mouseup', this.handleMouseUpEvent, true);
    }
    if (this.frameRight && this.frameRight.contentWindow && this.frameRight.contentWindow.document) {
      this.frameRight.contentWindow.document.removeEventListener('mouseup', this.handleMouseUpEvent, true);
    }
    if (this.divMagicScrollerContainer) {
      this.divMagicScrollerContainer.removeEventListener('mousemove', this.handleMouseMoveEvent, true);
    }
    if (this.div) {
      this.div.removeEventListener('mousedown', this.handleMouseDownEvent, true);
    }
    // divMagicScrollerContainer.removeEventListener('mousemove',this.handleMouseMoveEvent, true);
    // div.removeEventListener('mousedown', this.handleMouseDownEvent, true);
  }

  private makeIframeUnload() {
    this.isLeftFrameLoaded = false;
    this.isRightFrameLoaded = false;
    this.translationModel = new TranslationModel();
    this.processTranslationModel();

  }

  handleMagicSliderData(frameLeft: any, frameRight: any) {
    this.frameLeft = frameLeft;
    this.frameRight = frameRight;
    // const div = <HTMLElement>document.getElementById('dummy-scroll-container-range');
    // const divMagicScrollerContainer = <HTMLElement>document.getElementById('magic-scroller-container');
    this.div.addEventListener('mousedown', this.handleMouseDownEvent, true);
    document.addEventListener('mouseup', this.handleMouseUpEvent, true);
    frameLeft.contentWindow.document.addEventListener('mouseup', this.handleMouseUpEvent, true);
    frameRight.contentWindow.document.addEventListener('mouseup', this.handleMouseUpEvent, true);
    this.divMagicScrollerContainer.addEventListener('mousemove', this.handleMouseMoveEvent, true);
    window.addEventListener('resize', this.handleWindowResizeEvent, true);
    // this.divIconSquareUp.addEventListener('mousedown', this.handleiconSquireUpEvent, true);
    // this.divIconSquareDown.addEventListener('mousedown', this.handleiconSquireDownEvent, true);
  }

  handleiconSquireUpEvent = () => {
    const maxIconClickable = 10;
    const rightFrameHeight = this.frameRight.contentDocument.querySelector('body').scrollHeight;
    const leftFrameHeight = this.frameLeft.contentDocument.querySelector('body').scrollHeight;
    const rightFrameScrollTop = this.frameRight.contentWindow.scrollY;
    const leftFrameScrollTop = this.frameLeft.contentWindow.scrollY;
    if (rightFrameHeight - leftFrameHeight >= 0) {
      this.frameLeft.contentWindow.scrollTo(0, (leftFrameScrollTop) - (leftFrameHeight / maxIconClickable));
      this.frameRight.contentWindow.scrollTo(0, (rightFrameScrollTop) - (leftFrameHeight / maxIconClickable));
    } else {
      // if(rightFrameScrollTop>100){
      this.frameLeft.contentWindow.scrollTo(0, (leftFrameScrollTop) - (rightFrameHeight / maxIconClickable));
      this.frameRight.contentWindow.scrollTo(0, (rightFrameScrollTop) - (rightFrameHeight / maxIconClickable));
      // }
    }

    // console.log("Up fired");
  }
  handleiconSquireDownEvent = () => {
    const maxIconClickable = 10;
    const rightFrameHeight = this.frameRight.contentDocument.querySelector('body').scrollHeight;
    const leftFrameHeight = this.frameLeft.contentDocument.querySelector('body').scrollHeight;
    const rightFrameScrollTop = this.frameRight.contentWindow.scrollY;
    const leftFrameScrollTop = this.frameLeft.contentWindow.scrollY;
    if (rightFrameHeight - leftFrameHeight >= 0) {
      this.frameLeft.contentWindow.scrollTo(0, (leftFrameScrollTop) + (leftFrameHeight / maxIconClickable));
      this.frameRight.contentWindow.scrollTo(0, (rightFrameScrollTop) + (leftFrameHeight / maxIconClickable));
    } else {
      this.frameLeft.contentWindow.scrollTo(0, (leftFrameScrollTop) + (rightFrameHeight / maxIconClickable));
      this.frameRight.contentWindow.scrollTo(0, (rightFrameScrollTop) + (rightFrameHeight / maxIconClickable));
    }
    // console.log("Down fired");
  }
  handleMouseMoveEvent = (event) => {
    event.preventDefault();
    // const div = <HTMLElement>document.getElementById('dummy-scroll-container-range');
    const rightFrameScrollTop = this.frameRight.contentWindow.scrollY;
    const leftFrameScrollTop = this.frameLeft.contentWindow.scrollY;
    let down;
    const rightframebody = this.frameRight.contentDocument.querySelector('body');
    const rightFrameHeight = rightframebody.scrollHeight;
    const leftframebody = this.frameLeft.contentDocument.querySelector('body');
    const leftFrameHeight = leftframebody.scrollHeight;

    const scrollnumber = this.div.offsetTop;
    const newValue = scrollnumber;
    if (this.isDown) {
      this.mousePosition = {
        x: 0,
        y: screenPxToLocal(event.clientY, this.dragZoom)
      };
      this.div.style.top = (this.mousePosition.y + this.offset[1]) + 'px';
      if (this.mousePosition.y + this.offset[1] < 0) {
        this.div.style.top = 0 + 'px';
      }
      if (this.mousePosition.y + this.offset[1] >= this.clientHeight) {
        this.div.style.top = (this.clientHeight) + 'px';
      }
    }

    if (leftFrameHeight > 0 && rightFrameHeight > 0) {
      if (rightFrameHeight >= leftFrameHeight) {
        this.lowLengthSide = leftFrameHeight;
      } else if (rightFrameHeight < leftFrameHeight) {
        this.lowLengthSide = rightFrameHeight;
      }
    }
    const diff = Math.abs(this.oldValue - newValue);

    if (this.oldValue - newValue < 0) {
      down = true;
      // console.log("Scrolling Down");
      // console.log("Both",lowLengthSide,clientHeight,leftFrameHeight,rightFrameHeight);
      this.frameLeft.contentWindow.scrollTo(0, diff * (this.lowLengthSide / this.clientHeight) + (leftFrameScrollTop));
      this.frameRight.contentWindow.scrollTo(0, diff * (this.lowLengthSide / this.clientHeight) + (rightFrameScrollTop));
    } else if (this.oldValue - newValue > 0) {
      down = false;
      // console.log("Scrolling Up");
      this.frameLeft.contentWindow.scrollTo(0, leftFrameScrollTop - diff * (this.lowLengthSide / this.clientHeight));
      this.frameRight.contentWindow.scrollTo(0, rightFrameScrollTop - diff * (this.lowLengthSide / this.clientHeight));
    }
    this.oldValue = newValue;

  }
  handleMouseDownEvent = (e) => {
    // const div = <HTMLElement>document.getElementById('dummy-scroll-container-range');
    this.isDown = true;
    this.dragZoom = effectiveZoom(this.div);
    this.offset = [
      0,
      this.div.offsetTop - screenPxToLocal(e.clientY, this.dragZoom)
    ];
    // console.log("mouseDown");
  }
  handleMouseUpEvent = () => {
    this.isDown = false;
    // console.log("mouseUP fired");
  }
  handleWindowResizeEvent = () => {
    // var div = <HTMLElement>document.getElementById('dummy-scroll-container-range');
    const newWindowValue = document.body.clientHeight;
    const barTop = document.getElementById('dummy-scroll-container').offsetHeight - 25;
    if (this.oldWindowValue - newWindowValue > 0) {
      this.div.style.top = barTop + 'px';
    }
    // console.log(document.body.clientWidth + ' wide by ' + document.body.clientHeight+' high');
    this.oldWindowValue = newWindowValue;
  }

  private listenFrameEditDirtyNess(frameId: string) {
    const frame = <HTMLIFrameElement>document.getElementById(frameId);
    frame.contentWindow.document.addEventListener('keyup', () => {
      // console.log('left form dirty keyup');
    });
    // let oldValue=0
    frame.contentWindow.document.addEventListener('scroll', () => {

    });

    frame.contentWindow.document.addEventListener('mouseup', () => {
      // console.log('left form dirty mouseup');
    });
  }

  private requestTranslation(fileId: any, fromLang: string = '', toLang: string = '') {
    this.translationService.requestTranslation(this.translationId, fileId, fromLang, toLang).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      if (response) {
        this.fuseSplashScreenService.hide();
        this.handler.magicLinkModelValueChanged.emit({id: 'PlatformToolContainerComponent', value: response});
      } else {
        this.snackBarService.showError('Traslation failed.');
      }
    });
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
  }
}
